export enum ResolveLookupOutcome {
  Found = 1,
  OrderNotFound = 2,
  MerchantNotFound = 3,
}

export const ResolveLookupOutcomeLabels: { [key in ResolveLookupOutcome]: string } = {
  [ResolveLookupOutcome.Found]: 'Found',
  [ResolveLookupOutcome.OrderNotFound]: 'Order Not Found',
  [ResolveLookupOutcome.MerchantNotFound]: 'Merchant Not Found',
};

export interface DigitalReceiptItem {
  id: string | number;
  productId: string | number;
  productName: string;
  quantity: number;
  productPrice: string;
}

export interface DigitalReceiptName {
  givenName: string;
  familyName: string;
}

export enum DigitalReceiptActionType {
  ViewOrder = 'VIEW_ORDER',
  BuyAgain = 'BUY_AGAIN',
  Refund = 'REQUEST_REFUND',
}

export const DigitalReceiptActionTypeLabels: { [key in DigitalReceiptActionType]: string } = {
  [DigitalReceiptActionType.ViewOrder]: 'View Order',
  [DigitalReceiptActionType.BuyAgain]: 'Buy Again',
  [DigitalReceiptActionType.Refund]: 'Request Refund',
};

export interface DigitalReceiptActionLink {
  linkUrl: string;
  linkType: DigitalReceiptActionType;
}

export interface DigitalReceiptOrder {
  merchantOrderId: string | number;
  orderDateTime: string;
  orderEmail: string;
  orderPhone: string;
  subtotal: string;
  total: string;
  currencyCode: string;
  orderItems: DigitalReceiptItem[];
  orderRecipientName: DigitalReceiptName;
  callToActionLinks: DigitalReceiptActionLink[];
}

export enum DigitalReceiptStatusCode {
  Found = 'TRANSACTION_FOUND',
  NotFound = 'TRANSACTION_NOT_FOUND',
}

export interface DigitalReceiptStatus {
  code: DigitalReceiptStatusCode;
  message: string;
}

export interface DigitalReceipt {
  responseStatus: DigitalReceiptStatus;
  order?: DigitalReceiptOrder;
}
